import React from 'react';
import { COMMON_IMAGES } from 'src/data/constants';
import './Header.css';

export const Header = () => {
  return (
    <header className='lnl-header row'>
      <img src={COMMON_IMAGES.logo} className='logo' alt='logo' />
      <div className='lnl-header-text'>
        <p className='header-title'>Lights &amp; Lenses</p>
        <p className='header-subtitle'>Digital Photography</p>
      </div>
    </header>
  );
};
